const actions = {
	ACCOUNT_CREATE_TAKE_TO_NEXT_STEP: 'ACCOUNT_CREATE_TAKE_TO_NEXT_STEP',
	takeToNextStep: ({ path } = {}) => ({
		type: actions.ACCOUNT_CREATE_TAKE_TO_NEXT_STEP,
		path,
	}),
};

export default actions;
